import AbsComponent from "./AbsComponent";

export default class PointAbilityLayer extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);

        this.addEvents();
    }

    addEvents(){
        $('.contents-wrap > .info-ability .btn-point-Ability').on('click', e => {
            $('#pointAbility').show();
        })
        $('#pointAbility .btn-close-layer').on('click', e => {
            $('#pointAbility').hide();
        })
    }

    setting(_abilityData, _pointData){
        if (!_abilityData.data.point_ability) return false;
        if (!_pointData) return false;

        _abilityData = _abilityData.data;
        _pointData = _pointData.data ;

        $('#point-attack_power_value').text(_abilityData.point_ability.attack_power_value);
        $('#point-attack_attribute_value').text(_abilityData.point_ability.attack_attribute_value);

        $('#point-max_hp').text(_abilityData.point_ability.max_hp);
        $('#point-defend_power_value').text(_abilityData.point_ability.defend_power_value);

        let offenseList = _pointData.map(it=>{
            return (it.type === 'offense')? `
            <li class="${_abilityData.point_ability.offense_point >= it.point?'':'disabled'}">
                <span class="bonus">${it.point}</span> ${it.description}
            </li>`: '';
        }).join('');

        let defenseList = _pointData.map(it=>{
            return (it.type === 'defense')? `
            <li class="${_abilityData.point_ability.defense_point >= it.point?'':'disabled'}">
                <span class="bonus">${it.point}</span> ${it.description}
            </li>`: '';
        }).join('');

        $('#pointAbility .stat-bonus-list-offense').empty().append(offenseList);
        $('#pointAbility .stat-bonus-list-defense').empty().append(defenseList);



        let pickOffense = _abilityData.point_ability.picks.map( it => {
            if (it.point !== 0 && (it.slot === 1 || it.slot === 4)) {
                return `
                <li>
                    <div class="selected-effect-title">
                        <span class="title-icon icon-attack-${it.slot}"></span>
                        <em class="title-text">${it.name} ${it.tier}${this.l10n.step}</em>
                    </div>
                    <span class="selected-effect-info">${it.description}</span>
                </li>`;
            }
        }).join('');

        let pickDefense = _abilityData.point_ability.picks.map( it => {
            if (it.point !== 0 && (it.slot === 2 || it.slot === 3 || it.slot === 5)) {
                return `
                <li>
                    <div class="selected-effect-title">
                        <span class="title-icon icon-attack-${it.slot}"></span>
                        <em class="title-text">${it.name} ${it.tier}${this.l10n.step}</em>
                    </div>
                    <span class="selected-effect-info">${it.description}</span>
                </li>`;
            }
        }).join('');

        if (pickOffense=='' && pickDefense=='') {
            $('#pointAbility .stat-select').hide();
        }

        $('#pointAbility .stat-select-list-offense').empty().append(pickOffense);
        $('#pointAbility .stat-select-list-defense').empty().append(pickDefense);
    }



} // end of class